import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import TopBar from "../../../components/TopBar/TopBar";
import Navbar from "../../../components/Navbar/Navbar";

import "./ProjectUiDev.css";
import { client } from "../../../client";
import { Link } from "react-router-dom";
import Button from "../../../components/Button/Button";
import ButtonBehance from "../../../components/Button/ButtonBehance";
import TopBarSingleProject from "../../../components/TopBar/TopBarSingleProject";

const ProjectUiDev = () => {
  // add this is all pages to reset the Scroll position

  useEffect(() => {
    window.scrollTo(0, 0);

    const handleScroll = () => {};

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // this is for page title

  useEffect(() => {
    // Set the page title when the component mounts
    document.title = "UI/UX Design Project - Shreeyash Parsawar | Portfolio";
  }, []);

  // api featch data

  const [projectuidesignsection, setProjectuidesignsection] = useState([]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const query = `*[_type == "projectuiuxdesign"]{
                id,
                projectname,
                projectlink,
                projectshortdesc,
                projectimg{
                asset->{
                    _id,
                    url
                }
            }
                
            } | order(id desc) `;

    client.fetch(query).then((data) => {
      setProjectuidesignsection(data);
      setLoading(false);
    });
  }, []);

  if (!projectuidesignsection) return <div className="spinner"></div>;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 3 }}
    >
      {loading ? (
        <div className="spinner"></div>
      ) : (
        <section className="sectionProjectUiDev ">
          <TopBarSingleProject />
          <div className="container-fluid  text-center">
            <div className="row">
              {/* ---------------------------------------------------------------------------- */}

              {/* Project  section  */}

              <div className="container-fluid">
                <div className="row">
                  {projectuidesignsection && (
                    <div className="col-lg-12 mt-5 ">
                      <h1 className="text-capitalize fontpara">
                        I've completed {projectuidesignsection.length} Ui/UX
                        projects, and many more are coming soon....
                      </h1>
                    </div>
                  )}
                </div>
              </div>

              <div className="container-fluid  my-5">
                <div className="row">
                  {projectuidesignsection &&
                    projectuidesignsection.map((pdata, index) => (
                      <div className="col-lg-4 col-md-6"  key={index}>
                        {/* main div  */}

                        <div className="container-fluid knowledge_div">
                          <div className="row">
                            {/* project photo section  */}

                            <div className="col-lg-12 text-center">
                              <img
                                src={pdata.projectimg.asset.url}
                                className="img-fluid"
                                alt=""
                                style={{}}
                              />
                            </div>

                            {/* project photo section  */}

                            {/* Project Detials section  */}

                            <div className="col-lg-12 d-flex flex-column">
                              <div className="">
                                <h1 className="project_title">
                                  {pdata.projectname}
                                </h1>
                                <p className="project_desc">
                                  {pdata.projectshortdesc
                                    ? pdata.projectshortdesc
                                    : "No Short Description is Given"}
                                </p>
                              </div>

                              <div className="mt-auto text-center">
                                <Link to={pdata.projectlink}>
                                  <ButtonBehance title={"Explore on"} />
                                </Link>
                              </div>
                            </div>

                            {/* Project Detials section  */}
                          </div>
                        </div>

                        {/* main div  */}
                      </div>
                    ))}
                </div>
              </div>
              {/*Project  section  */}

              {/* ---------------------------------------------------------------------------- */}
            </div>
          </div>

          {/* <Navbar /> */}
        </section>
      )}
    </motion.div>
  );
};

export default ProjectUiDev;
